import { atom } from 'jotai'
import { type PropsAlert } from 'src/components/atoms/alert/Alert'
import { ActionItem } from '../types/PagePrimary.type'

type AlertAtom = {
  title?: string
  content?: string
  variant?: 'primary' | 'danger' | 'warning' | 'success'
  size?: 'small' | 'large'
  color?: PropsAlert['color']
  icon?: 'ic:baseline-check' | 'ic:baseline-do-disturb'
  pathname?: string
  open?: boolean
}

export const alertAtom = atom<AlertAtom>({
  title: '',
  content: '',
  variant: 'primary',
  size: 'small',
  color: 'success',
  icon: 'ic:baseline-check',
  pathname: '',
  open: false
})

export const currentActionAtom = atom<ActionItem | null>(null)
